export default "__VITE_ASSET__j4RpxR3n__"